export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7691.94b43ec4.jpg";